import { useEffect } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowRefresh2, Service } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './ErrorFallback.module.scss'

const ErrorFallback = () => {
  return (
    <Modal.Root size="sm" isKeyboardDismissDisabled onPressOutside={() => {}}>
      <Modal.Header className={Styles.header}>
        <Service color="var(--dark-80)" />
        <Heading level={4}>Something went wrong!</Heading>
      </Modal.Header>
      <Modal.Content>
        <Text variant="primary">Please refresh your browser or click the button below to continue designing.</Text>
      </Modal.Content>
      <Modal.Footer>
        <Button
          size="md"
          frontIcon={ArrowRefresh2}
          onPress={() => {
            // eslint-disable-next-line no-restricted-properties
            window.location.reload()
          }}
        >
          Refresh
        </Button>
      </Modal.Footer>
    </Modal.Root>
  )
}

const ErrorFallbackContainer = () => {
  const { openModal } = useModals()

  useEffect(() => {
    openModal(ErrorFallback)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export { ErrorFallbackContainer as ErrorFallback }
